import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { previewLeaderMessage } from '../../lib/frameworks';

/**
 * Exactly what the leader who asked will get, by email and on their phone,
 * rendered from the same code that sends it, updating as the note is typed.
 */
export function LeaderMessagePreview({
  requestId,
  status,
  note = '',
  who = 'the leader',
}: {
  requestId: string;
  status: 'ready' | 'needs_info' | 'declined';
  note?: string;
  who?: string;
}) {
  const [settled, setSettled] = useState(note);
  useEffect(() => {
    const t = setTimeout(() => setSettled(note), 350);
    return () => clearTimeout(t);
  }, [note]);
  const msg = useQuery({
    queryKey: ['leader-message', requestId, status, settled.trim()],
    queryFn: () => previewLeaderMessage(requestId, status, settled.trim()),
    placeholderData: (prev) => prev,
  });
  if (!msg.data) return null;
  return (
    <div className="msg-preview">
      <p className="eyebrow">What {who} gets</p>
      <div className="msg-preview-push">
        <span className="msg-preview-label">On their phone</span>
        <strong>{msg.data.push.title}</strong>
        <span>{msg.data.push.body}</span>
      </div>
      <div className="msg-preview-email">
        <span className="msg-preview-label">
          Email &middot; <strong>{msg.data.subject}</strong>
        </span>
        <iframe title="Email preview" sandbox="" srcDoc={msg.data.html} />
      </div>
    </div>
  );
}
